import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import Keyboard from 'react-simple-keyboard'
import 'react-simple-keyboard/build/css/index.css'
import './keyboard.css'

const VirtualKeyboard = ({ onKeyPress }) => {
    const keyboardRef = useRef(null)
    const [layout, setLayout] = useState('default')

    const handleKeyPress = (key) => {
         if (key === '{numbers}') {
            setLayout('numbers')
        } else if (key === '{abc}') {
            setLayout('default')
        } else {
            onKeyPress(key)
        }
    }
    return (
        <div className='VirtualKeyboard'>
            <Keyboard
                layoutName={layout}
                layout={{
                    default: [
                        'Q W E R T Y U I O P',
                        'A S D F G H J K L',
                        'Z X C V B N M {backspace}',
                        '{numbers} {space} {ent}'
                    ],
                    numbers: ['1 2 3', '4 5 6', '7 8 9', '{abc} 0 {backspace}'],
                }}
                display={{
                    '{numbers}': '123',
                    '{ent}': 'return',
                    '{escape}': 'esc ⎋',
                    '{tab}': 'tab ⇥',
                    '{backspace}': '⌫',
                    '{capslock}': 'caps lock ⇪',
                    '{shift}': '⇧',
                    '{controlleft}': 'ctrl ⌃',
                    '{controlright}': 'ctrl ⌃',
                    '{altleft}': 'alt ⌥',
                    '{altright}': 'alt ⌥',
                    '{metaleft}': 'cmd ⌘',
                    '{metaright}': 'cmd ⌘',
                    '{abc}': 'ABC',
                    '{space}': ' ',
                }}
                onKeyPress={handleKeyPress}
                keyboardRef={r => keyboardRef.current = r} />
        </div>
    )
}

VirtualKeyboard.propTypes = {
    onKeyPress: PropTypes.func,
}

export default VirtualKeyboard
